var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['partner-box text-center pointer', {'selected' : _vm.isSelected}],on:{"click":_vm.onClick}},[_vm._t("icon")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }